// @flow

import { createContext } from 'react';

const ZoteroTranslateContext = createContext();

export default ZoteroTranslateContext;
